import fetchMock from 'fetch-mock';

import { medlemskapMock } from './medlemskap-mock';
import { receiptMock } from './receipt-mock';
import { discountMock } from './discount-mock';

fetchMock.get('/bli-medlem/api/Medlemskapstyper', { body: medlemskapMock(), status: 200 }, { delay: 0 });

fetchMock.get('express:/bli-medlem/api/Receipt/:recieptId', { body: receiptMock, status: 200 }, { delay: 300 });

fetchMock.post(
    '/bli-medlem/api/StartSession',
    {
        body: {
            token: 'test-token',
            checkoutFrontendUrl: 'http://localhost:3000',
        },
        status: 200,
    },
    { delay: 1000 }
);

fetchMock.post('/bli-medlem/api/ValidateDiscountCode', { body: discountMock, status: 200 }, { delay: 0 });
